<script setup>
import { computed } from "vue";

const props = defineProps({
  text: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "info",
  },
  title: {
    type: String,
    default: "Recuerda",
  },
});

const ICONS = {
  warning: "fa-solid fa-triangle-exclamation",
  info: "fa-solid fa-circle-info",
};

const tone = computed(() => {
  const t = props.type.trim().toLowerCase();
  return t === "warning" || t === "warn" ? "warning" : "info";
});

const iconClass = computed(() => ICONS[tone.value]);

const bodyText = computed(() => props.text.trim());
</script>

<template>
  <div class="alert-note alert-note--premium" :class="`alert-note--${tone}`" role="alert">
    <div class="alert-note__icon-wrap" aria-hidden="true">
      <i :class="iconClass"></i>
    </div>

    <div class="alert-note__content">
      <h6 class="alert-note__title">{{ title }}</h6>
      <div class="alert-note__body">
        <slot v-if="$slots.default" />
        <p v-else-if="bodyText" class="alert-note__text mb-0">
          {{ bodyText }}
        </p>
      </div>
    </div>
  </div>
</template>
